import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-calendar-multi-overlay',
  templateUrl: './calendar-multi-overlay.component.html',
  styles: [
    `
      app-calendar-multi {
        position: absolute;
        left: 1rem;
        right: 1rem;
        bottom: 1rem;
        top: 1rem;
      }
    `,
  ],
})
export class CalendarMultiOverlayComponent {
  constructor(public dialogRef: MatDialogRef<CalendarMultiOverlayComponent>) {}

  close() {
    this.dialogRef.close()
  }
}
